class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);



const closeSearch = document.getElementById('close-search');
const floatingSearch = document.getElementById('floating-search2');
const overlay = document.getElementById('floating-search-overlay');

// Función para abrir el buscador

  function openSearch(){
    floatingSearch.classList.add('active');
    overlay.classList.add('active');
   
  }

// Función para cerrar el buscador
const closeFloatingSearch = () => {
  floatingSearch.classList.remove('active');
  overlay.classList.remove('active');
};

// Cerrar con el botón de cerrar
closeSearch.addEventListener('click', closeFloatingSearch);

// Cerrar haciendo clic en el overlay
overlay.addEventListener('click', closeFloatingSearch);
